import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component'
import { NgModel } from '@angular/forms';
import { questionMaxCheckedOptionCntValidator } from './question-max-checked-option-cnt-validator.fn';

@Component({
  selector: 'question-checkbox',
  templateUrl: './question-checkbox.component.html',
  styleUrls: ['./question-checkbox.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class QuestionCheckboxComponent extends QuestionComponent {
  @ViewChild('max_checked_option_cnt') max_checked_option_cnt:NgModel; 
  ngOnInit() {
    super.ngOnInit();
    this.addControls();
  }
  ngOnDestroy () {
    this.removeControls();
    super.ngOnDestroy();
  }
  refreshView () {
    this.max_checked_option_cnt.control.updateValueAndValidity();
    super.refreshView();
  }
  private addControls () {
    this.max_checked_option_cnt.control.setValidators(questionMaxCheckedOptionCntValidator(this.question));  
    if (this.questionFormGroup) this.questionFormGroup.setControl('max_checked_option_cnt', this.max_checked_option_cnt.control);
  }
  private removeControls () {
    this.questionFormGroup.removeControl('max_checked_option_cnt');
  }

  
}
